import { render, staticRenderFns } from "./ProductSubClassManagement.vue?vue&type=template&id=6c37aa4b&scoped=true"
import script from "./ProductSubClassManagement.vue?vue&type=script&lang=js"
export * from "./ProductSubClassManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductSubClassManagement.vue?vue&type=style&index=0&id=6c37aa4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37aa4b",
  null
  
)

export default component.exports